import React, { useState, useEffect } from 'react';
import { Button, Skeleton, Stack } from '@mui/material';

import Storage from 'src/utils/storage/storage';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import './section.scss';
import {
  getRecentlyOpenedList,
  setActiveBottomTab
} from '../../../store/landing-slice';
import PageListComponent from './page-list-component';

export default function RecentlyOpenComponent() {
  const appDispatch = useAppDispatch();

  // getting the favorite list from store
  const { isRecentlyOpenedListFetching, recentlyOpenedList } = useAppSelector(
    (state) => state.landing
  );

  // getting the source id from storage
  const { source: sourceId } = Storage.getSourceId();
  // useeffect for getting the recently opened list
  useEffect(() => {
    appDispatch(getRecentlyOpenedList({ sourceId }));
  }, []);

  // loading skeleton
  const loadingSkeleton = () => {
    const a = [1, 1, 1, 1];
    return (
      <>
        {a.map((e) => (
          <Stack spacing={1} margin={1}>
            <Skeleton
              animation='wave'
              variant='rectangular'
              width='100%'
              height={30}
            />
          </Stack>
        ))}
      </>
    );
  };
  // updating the activeBottomTab redux variable to Quick Start
  const handleStartButton = () => {
    const tabToOpen = 'Quick Start';
    appDispatch(setActiveBottomTab(tabToOpen));
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {isRecentlyOpenedListFetching ? (
        loadingSkeleton()
      ) : recentlyOpenedList.length > 0 ? (
        // calling page list component
        <PageListComponent
          pageList={recentlyOpenedList}
          sectionType='recently-open'
        />
      ) : (
        <>
          <div className='info-text-msg'>
            Reports you accessed last will show up here
          </div>
          <div className='recently-open-footer'>
            <div className='recently-open-footer-msg'>
              Click below to get started
            </div>
            <Button variant='contained' onClick={handleStartButton}>
              Start Here
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
